import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { AccountService } from './core/auth/account.service';
import { DATE_LOCALE } from './shared/constants/general.constants';

/**
 * Clase principal de la aplicacion.
 */
@Component({
  selector: 'tel-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private subscripcion: Subscription;

  private esRefrescoNavegador: boolean;

  constructor(@Inject(LOCALE_ID) private locale: string, @Inject(DOCUMENT) private document: Document, private dateAdapter: DateAdapter<any>, private translate: TranslateService, private accountService: AccountService, private router: Router) {}

  ngOnInit() {
    this.document.documentElement.lang = this.locale;
    this.dateAdapter.setLocale(DATE_LOCALE);

    this.translate.setDefaultLang(environment.defaultLang);
    this.translate.use(environment.defaultLang);

    if (!this.accountService.isAuthenticated()) {
      // Redirección al SSO y gestión del token de seguridad
      this.accountService.resolveAccount();
    }

    this.controlarRefrescoPagina();
  }

  private controlarRefrescoPagina() {
    this.subscripcion = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.esRefrescoNavegador = !this.router.navigated && !this.esRefrescoNavegador;
        if (this.esRefrescoNavegador) {
          this.irAPaginaInicial();
        }
      }
    });
  }

  private irAPaginaInicial() {
    if(window.location.pathname != '/tel/' ){
      console.log('app.component.ts: irAPaginaInicial(): redirigimos a la pagina inicial');
      this.router.navigate(['']);
    }
  }

  ngOnDestroy(): void {
    this.subscripcion.unsubscribe();
  }
}
